import React from "react";
import { BrowserView, MobileView } from "react-device-detect";
import DesktopModalLayout from "src/bepaid/components/Modal/components/DesktopModalLayout";
import { FetchModalID } from "src/ipm-shared/components/GlobalUI/actions";

import ChangeEmail from "src/bepaid/layouts/Menu/components/ChangeEmail";
import MainLayout from "src/bepaid/layouts/MainLayout";

import styles from "./ChangeEmailModal.module.scss";

const View = (props: any) => {
  const toggleModal = () => {
    props.toggleModal(FetchModalID.CHANGE_EMAIL);
  };

  const onSaved = () => {
    toggleModal();
  };

  const renderContent = () => (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <ChangeEmail onSaved={onSaved} />
      </div>
    </div>
  );

  return (
    <>
      <BrowserView>
        <DesktopModalLayout title={"Change email"} onClose={toggleModal}>
          {renderContent()}
        </DesktopModalLayout>
      </BrowserView>
      <MobileView>
        <MainLayout
          header={{
            title: "Change email",
            hideMenu: true,
            onClose: toggleModal
          }}
        >
          {renderContent()}
        </MainLayout>
      </MobileView>
    </>
  );
};

export default View;
